/**
 * External dependencies
 */
import $ from "jquery";

export const $win = $(window);
export const $document = $(document);
export const $body = $("body");

document.addEventListener("DOMContentLoaded", function () {
	// Zoek naar alle elementen met de class .section-richtext
	const sections = document.querySelectorAll(".section-richtext");

	if (sections.length > 0) {
		sections.forEach((section) => {
			// Zoek binnen elke .section-richtext naar alle table elementen
			const tables = section.querySelectorAll("table");

			tables.forEach((table) => {
				// Maak een nieuw figure element
				const figure = document.createElement("figure");

				// Voeg de gewenste class toe aan het figure element
				figure.classList.add("wp-block-table");

				// Voeg de table toe aan het figure element
				table.parentNode.insertBefore(figure, table);
				figure.appendChild(table);
			});
		});
	}
});
